export default {
  firstName: 'Имя',
  lastName: 'Фамилия',
  middleName: 'Отчество',
}
